import React, { useEffect, useState, useRef } from 'react';
export function Section({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) {
  const ref = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(el);
      }
    }, {
      rootMargin: '-80px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <section ref={ref} id={id} className={`py-16 md:py-24 px-4 max-w-4xl mx-auto transition-all duration-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'} ${className}`} style={{
    transitionDuration: '600ms'
  }} data-id="element-225">
      {children}
    </section>;
}